import { IFormSection, TSubmitType } from "../../types/common";
import { URL_ASSIGNED_TICKETS } from "../../utils/urls";
import { getRegister, getResultOptions } from "../../utils/helpers";
import { INCIDENT_TICKETING_API, TICKETABLE_USERS_API } from "../../utils/apis";
import useGet from "../common/useGet";
import { useEffect } from "react";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useTicketEscalationForm = () => {
  const sections: IFormSection[] = [
    {
      title: "Ticket Escalation",
      fields: [
        {
          field_name: "escalated_to",
          type: "select",
          label: "Escalate To",
          options_name: "asigned_users",
          props: { required: true },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_ASSIGNED_TICKETS);

  const getConfigOptions = () => {
    const { loadData: getAssignedUsers, data: asigned_users } = useGet();

    useEffect(() => {
      getAssignedUsers({
        api: TICKETABLE_USERS_API,
        params: {},
      });
    }, []);

    return {
      asigned_users: getResultOptions(asigned_users, "name", "value"),
    };
  };

  const options = getConfigOptions();

  return { sections, redirect, options };
};

export function submitTicketEscalation(payload: any, id: number | null) {
  return {
    api: `${INCIDENT_TICKETING_API}${id}/escalate/`,
    params: payload,
    method: "POST",
  };
}
